import { render, staticRenderFns } from "./empty-content.vue?vue&type=template&id=10ca32b5&"
import script from "./empty-content.vue?vue&type=script&lang=js&"
export * from "./empty-content.vue?vue&type=script&lang=js&"
import style0 from "./empty-content.vue?vue&type=style&index=0&id=10ca32b5&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports